(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CustomerDialogController', CustomerDialogController);

    CustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Customer', 'DoctorSpecialty', 'CustomerCategory', 'CustomerSector', 'CustomerTitle', 'CustomerSubCategory', 'CustomerType', 'Collaboration'];

    function CustomerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Customer, DoctorSpecialty, CustomerCategory, CustomerSector, CustomerTitle, CustomerSubCategory, CustomerType, Collaboration) {
        var vm = this;
        vm.customer = entity;
        vm.doctorspecialties = DoctorSpecialty.query();
        vm.customercategories = CustomerCategory.query();
        vm.customersectors = CustomerSector.query();
        vm.customertitles = CustomerTitle.query();
        vm.customersubcategories = CustomerSubCategory.query();
        vm.customertypes = CustomerType.query();
        vm.collaborations = Collaboration.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:customerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.customer.id !== null) {
                Customer.update(vm.customer, onSaveSuccess, onSaveError);
            } else {
                Customer.save(vm.customer, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};

        vm.setProfilePhoto = function ($file, customer) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        customer.profilePhoto = base64Data;
                        customer.profilePhotoContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.lastVisitDate = false;

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
